<template>
  <div class="articles-page">
    <div class="container">
      <div class="articles-page__breadcrumbs">
        <Breadcrumbs :breadcrumbs="breadcrumbs" />
      </div>
      <h1 class="articles-page__title h2">Статьи </h1>
      <div class="articles-page__list">
        <template
          v-for="(item) in articles"
          :key="`article-${ item.id }`"
        >
          <ArticleCard :article="item" />
        </template>
      </div>

      <template v-if="Boolean(state.totalPages > 1)">
        <div class="articles-page__pagination">
          <Pagination
            :current-page="state.currentPage"
            :total-pages="state.totalPages"

            @change="changePage"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import useSitisArticleList from '#sitis/composables/useSitisArticles';
import Breadcrumbs from '~/components/UI/Breadcrumbs.vue';
import ArticleCard from '~/components/articles/ArticleCard.vue';
import type { IArticleItem } from '#sitis/internal/controllers/articles/models/ArticleItem';

const { setSEOTitles } = useSitisCMSPage();

const Pagination = defineAsyncComponent(() => import('~/components/UI/Pagination.vue'));

const {
  state,
  getArticleList,
  changeCurrentPage
} = useSitisArticleList({
  perPage: 20
  // categoryId: Number.parseFloat(payload?.config?.public?.articlesCategoryId || '2')
});

useLazyAsyncData('get-articles-list', async () => {
  return await getArticleList().then(() => true);
});

const articles = computed((): IArticleItem[] => {
  return state.value.articles;
});

const changePage = async (newPage: number) => {
  await changeCurrentPage(newPage);
};

const breadcrumbs = computed(() => {
  return [
    { title: 'Главная', path: '/' },
    { title: 'Статьи', path: '/articles' }
  ];
});

function initSeoData () {
  setSEOTitles({
    seoTitle: 'Статьи',
    seoDescription: 'Как выбрать первую кровать, как украсить детскую комнату, как организовать пространство в детской'
  });
}

initSeoData();
</script>

<style scoped lang="scss">
.articles-page {
}

.articles-page__breadcrumbs {
}

.articles-page__title {
	margin-bottom: 24px;
}

.articles-page__list {
	display: flex;
	flex-wrap: wrap;
	margin-top: -64px;
	margin-left: -20px;

	& > * {
		width: calc(100% / 5 - 20px);
		margin-top: 64px;
		margin-left: 20px;
	}
}

.articles-page__pagination {
	display: flex;
	justify-content: flex-end;
	margin-top: 64px;
}

@media (max-width: 1599px) {
	.articles-page__list > * {
		width: calc(100% / 4 - 20px);
	}
}

@media (max-width: 1439px) {
	.articles-page__list > * {
		width: calc(100% / 3 - 20px);
	}
}

@media (max-width: 1023px) {
	.articles-page__list {
		margin-top: -20px;
	}
	.articles-page__list > * {
		width: calc(100% / 2 - 20px);
		margin-top: 20px;
	}
}

@media (max-width: 859px) {
	.articles-page__list > * {
		width: calc(100% - 20px);
	}
}
</style>
